const AccessManagementBenefitsStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '100px 20px',
    backgroundColor: 'transparent', // No edges, blends with the page
    width: '100%',
  },
  textContainer: {
    textAlign: 'left',
    maxWidth: '700px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '2rem',
    color: '#000',
    marginBottom: '20px',
  },
  list: {
    paddingLeft: '10px',
  },
  listItem: {
    fontSize: '1.2rem',
    color: '#333',
    marginBottom: '12px',
  },
  boldText: {
    fontWeight: 'bold',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%', // Makes sure image stretches down
  },
  image: {
    width: '100%',
    maxWidth: '200px', // Ensures it scales properly
  },
};

export default AccessManagementBenefitsStyles;
